import { render } from "./count-badge.component.vue?vue&type=template&id=59a57d5c&ts=true"
import script from "./count-badge.component.vue?vue&type=script&lang=ts"
export * from "./count-badge.component.vue?vue&type=script&lang=ts"

import "./count-badge.component.vue?vue&type=style&index=0&id=59a57d5c&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__